import * as __WEBPACK_EXTERNAL_MODULE__assert_index_js_255db76f__ from "../assert/index.js";
function storeFactory(key, prefix) {
    (0, __WEBPACK_EXTERNAL_MODULE__assert_index_js_255db76f__.assert)(!!prefix, 'storeFactory: Expected valid prefix');
    (0, __WEBPACK_EXTERNAL_MODULE__assert_index_js_255db76f__.assert)(!!key, 'storeFactory: Expected valid key');
    const generateKey = (id)=>[
            prefix,
            key,
            id
        ].filter(Boolean).join('/');
    return {
        set: (data, id)=>{
            try {
                const key = generateKey(id);
                if (data) localStorage.setItem(key, JSON.stringify(data));
                else localStorage.removeItem(key);
            } catch (error) {
                console.error('storeFactory.set failed: ', error);
            }
        },
        get: (id)=>{
            try {
                const key = generateKey(id);
                const data = localStorage.getItem(key);
                if (data) return JSON.parse(data);
                return null;
            } catch (error) {
                console.error('storeFactory.get failed: ', error);
                return null;
            }
        },
        clear: (id)=>{
            try {
                const key = generateKey(id);
                localStorage.removeItem(key);
            } catch (error) {
                console.error('storeFactory.clear failed: ', error);
            }
        }
    };
}
export { storeFactory };
